import React, { Fragment, useContext, useEffect, useState, useRef, memo, useCallback, useReducer } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import cx from "classnames";
import { compareAsc, format, addDays, addMonths } from 'date-fns'
// Provider
import { AppContext } from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";

// UI
import { IC, Doctor } from "../../resources/Assets";

export const RightMenuLayer = memo((props) => {
    const { phonecfg} = useContext(AppContext);
    useEffect(() => {
        //우측 메뉴 토글
        $(".menuline-btn").click(function(){
            if(!$(this).hasClass("on")){
                $(".contents-container").addClass("fix");
                $(".contents-container").addClass("blur");

                $(this).addClass("on");
                $(".menu-right-contain").show();
                $(".menu-right-contain .in-r-menu").stop().animate({"right":0},250);
            }else{
                $(this).removeClass("on");
                $(".menu-right-contain .in-r-menu").stop().animate({"right":"-310px"},250,function(){
                    $(".menu-right-contain").hide();
                    $(this).removeAttr("style");

                    $(".contents-container").removeClass("blur");
                    $(".contents-container").removeClass("fix");
                });
            }
        });
    })

    return (
        <div className="menu-right-contain">
            <div>
                <div className="mrc-blind"></div>
                <div className="in-r-menu">
                    <div className="top-area">
                        <div>About US</div>
                    </div>
                    <div className="menu-list">
                        <ul>
                            <li><a href="link:https://mirabellsoft.co.kr/"><i className="c1"></i>회사소개</a></li>
                            <li><a href={void 0} onClick={(e) =>_O.OpenMenu("/mp/terms")}><i className="c2"></i>약관보기</a></li>
                            <li><a href={void 0} className="nbtn"><i className="c3"></i>버전정보  <u>V {phonecfg.version?phonecfg.version:'1.0.0'}</u></a></li>
                            <li><a href={void 0} onClick={(e) =>_O.OpenMenu("/mp/askUs")}><i className="c4"></i>문의하기</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
});